import React from 'react';

const ExitModalContext = React.createContext({
  isExitModalVisible: false,
  setIsExitModalVisible: (value: boolean) => {},
});

export default ExitModalContext;
